const Dashboard = {

    // FIELDS
    "premises": "Premises",
    "residents": "Residents",
    "tickets": "Tickets",

    "premise_tagline": "Overview of all managed premises",
    "resident_tagline": "People living in your community",
    "ticket_tagline": "All raised support requests",

    // PAGE HEADER
    "dashboard": "Dashboard",
    "facility_overview": "Facility Overview",
    "overview_subtitle": "Welcome back, Here is the architectural flow of your premises today.",
    "add_new_premise": "Add New Premise",
    "add_new_premise_subtitle": "Register a new residential or commercial unit to your management portfolio.",
    "register_new_premise": "Register New Premise",
    "facility_management": "Facility Management",
    "add_staff_member": "Add Staff Member",
    "add_staff_member_subtitle": "Expand your facility management team",
    "configure_access": "Configure Access",
    "ticket_board": "Ticket Board",
    "created_on": "Created",
    "created_by": "Created By",
    "assigned_to": "Assigned To",
    "assigned_by": "Assigned By",
    "no_tickets_available": "No recent tickets available.",
    "payment_due": "Payment Due",
    "due_amount": "Due Amount",
    "no_notices_available": "No recent notices or dues available.",

    "active_polls": "Active Polls",
    "submit_vote": "Submit Vote",
    "vote_submitted_success": "Your vote has been submitted successfully.",
    "results_after_close": "Results will be available after the poll closes.",
    "poll_closed_message": "This poll is now closed. Final results are shown below.",
    "total_votes": "Total Votes",
    "votes": "Votes",
    "closed": "Closed",
    "end_date": "End Date",
    "no_active_polls": "No active polls available.",
    "poll_of": "{{current}} of {{total}}",
    "previous_poll": "Previous poll",
    "next_poll": "Next poll",

}

export default Dashboard;